import { createSlice } from '@reduxjs/toolkit';
import { deleteMachineApi } from '@custom/rtk-apis/machine/deleteMachine';

const deleteSelectedMachineSlice = createSlice({
    name: 'deleteSelectedMachineSlice',
    initialState: {
      machinePayload: null,
      loading: false,
      error: null,
      success: false,
    },
    reducers: {
      reset: (state) => {
        state.machinePayload = null;
        state.loading = false;
        state.error = null;
        state.success = false;
      },
    },
    extraReducers: (builder) => {
      builder
        .addCase(deleteMachineApi.deleteSelectedMachineSlice.pending, (state) => {
          state.loading = true;
          state.error = null;
          state.success = false;
        })
        .addCase(deleteMachineApi.deleteSelectedMachineSlice.fulfilled, (state, action) => {
          state.machinePayload = action.payload;
          state.loading = false;
          state.success = true;
        })
        .addCase(deleteMachineApi.deleteSelectedMachineSlice.rejected, (state, action) => {
          state.loading = false;
          state.error = action.payload;
          state.success = false;
        });
    },
  });

  export default deleteSelectedMachineSlice.reducer;
  export const { reset } = deleteSelectedMachineSlice.actions
